import { useSyncExternalStore } from 'react';

export type FastApiEnv = 'old' | 'new';

const STORAGE_KEY = 'fast_api_env_pref';

const listeners = new Set<() => void>();
const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};
const notify = () => listeners.forEach((l) => l());

export const isFastApiEnvToggleAvailable = (): boolean =>
  (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'test') &&
  process.env.REACT_APP_IS_NEW_ENV === 'true' &&
  !!process.env.REACT_APP_FAST_API_NEW_URL;

export const getFastApiEnvPref = (): FastApiEnv => {
  if (!isFastApiEnvToggleAvailable()) return 'old';
  try {
    return localStorage.getItem(STORAGE_KEY) === 'new' ? 'new' : 'old';
  } catch {
    return 'old';
  }
};

export const setFastApiEnvPref = (env: FastApiEnv) => {
  try {
    localStorage.setItem(STORAGE_KEY, env);
  } catch {}
  notify();
};

export const getFastApiUrl = (): string => {
  if (
    isFastApiEnvToggleAvailable() &&
    getFastApiEnvPref() === 'new' &&
    process.env.REACT_APP_FAST_API_NEW_URL
  ) {
    return process.env.REACT_APP_FAST_API_NEW_URL;
  }
  return process.env.REACT_APP_FAST_API_URL ?? '';
};

export const useFastApiUrl = (): string =>
  useSyncExternalStore(subscribe, getFastApiUrl, getFastApiUrl);

export const useFastApiEnvPref = (): FastApiEnv =>
  useSyncExternalStore(subscribe, getFastApiEnvPref, getFastApiEnvPref);
